import { Component, OnInit, ViewChild } from '@angular/core';
import { DataManager, WebApiAdaptor, Query} from '@syncfusion/ej2-data';
import { GridComponent, PageEventArgs, PageSettingsModel, SelectionSettingsModel, ToolbarItems } from '@syncfusion/ej2-angular-grids';
import { HttpErrorResponse } from '@angular/common/http';
import { ActivatedRoute, Router } from '@angular/router';
import { FormBuilder, FormGroup } from '@angular/forms';
import { DatePipe } from '@angular/common';

import { SharedFunctions } from '../../../../src/app/shared/shared.functions';

import { MenuFuncionService, RolService } from '../../../../src/app/shared/services/index';
import { GridPageSettings, MenuFuncionCodes, MenuFuncion, SearchMenuFuncionRequestDto, SearchRolRequest, Rol,SearchMenuFuncionItemDto } from '../../../../src/app/shared/model';
import { ExportMediaTypeConstants } from '../../shared/model';

@Component({
  selector: 'app-menuLista',
  templateUrl: './menuLista.component.html',
})

export class MenuListaComponent implements OnInit {
  @ViewChild('grid')
  public grid: GridComponent;

  public data: DataManager;
  total: number = 0;
  searchForm: FormGroup;

  rolList: Rol[];
  menuPadreList: SearchMenuFuncionItemDto[];

  isValidating: boolean = false;
  isSearching: boolean = false;
  isExporting: boolean = false;
  isRolSearching: boolean = false;
  isMenuPadreSearching: boolean = false;

  canEdit: boolean = false;
  canView: boolean = false;
  canAdd: boolean = false;

  public query: Query;

  public selectionOptions: SelectionSettingsModel;
  public pageSizes: number[];
  public toolbarOptions: ToolbarItems[];
  public pageSettings: PageSettingsModel;

  constructor(
    private formBuilder: FormBuilder,
    private sharedFunctions: SharedFunctions,
    private router: Router,
    private route: ActivatedRoute,
    private service: MenuFuncionService,
    private rolService: RolService,
    private datePipe: DatePipe) {

  }

  ngOnInit(): void {
    this.isValidating = true;
    this.service.checkMenuPadre(MenuFuncionCodes.MENU).subscribe(data => {
      this.isValidating = false;
      if (data != null && data.Success && data?.Result){
        this.canAdd = data.Result.some(x => x == MenuFuncionCodes.MENU_ADD);
        this.canView = data.Result.some(x => x == MenuFuncionCodes.MENU_LIST);
          if (this.canView){
            this.loadView();
          } else {
            this.sharedFunctions.showMessage("No tiene permisos para acceder a esta vista", "Error");
            this.router.navigate(['/']);
          }
      }
      else {
        this.sharedFunctions.showMessage("No tiene permisos para acceder a esta vista", "Error");
        this.router.navigate(['/']);
      }
    },
    (err: HttpErrorResponse) => {
      this.isValidating = false;
      this.sharedFunctions.handleError(err, true);
    });
  }

  loadView() {
    this.buildForm();
    this.pageSizes = GridPageSettings.PageSizeList;
    this.pageSettings = { pageCount: GridPageSettings.PageCount, pageSize: this.pageSizes[1], pageSizes: this.pageSizes };


    var filtros = this.sharedFunctions.getReporteFiltros("app-menuFuncionLista");
    if (filtros != null) {
      this.searchForm.patchValue(filtros);
      if (filtros.gridPage != null && filtros.gridPage > 0)
        this.pageSettings.currentPage = filtros.gridPage;
    }

    this.setQueryParams();
    this.data = new DataManager({
      url: this.service.getSearchUrl(),
      adaptor: new WebApiAdaptor(),
      headers: [this.service.getAuthorizationHeader(),this.service.getTenantHeader()]
    });

    this.getRoles();
    this.getMenuPadres();
  }

  buildForm() {
    this.searchForm = this.formBuilder.group({
      'Codigo': [null],
      'Nombre': [null],
      'RolId': [null],
      'MenuPadreId': [null],
      'VerSoloActivos': [true],
      'gridPage': [1]
    });

    var filtros = this.sharedFunctions.getReporteFiltros("app-menuFuncionLista");
    if (filtros != null)
      this.searchForm.patchValue(filtros);
  }

  getRoles() {
    var r = new SearchRolRequest(null, null, true, "Nombre", null, null, null, true);
    this.isRolSearching = true;

    this.rolService.search(r).subscribe(data => {
      this.isRolSearching = false;
      if (data != null)
        this.rolList = data?.result;
    },
    (err: HttpErrorResponse) => {
      this.isRolSearching = false;
      this.sharedFunctions.handleError(err);
    });
  }

  getMenuPadres() {
    var r = new SearchMenuFuncionRequestDto(null, null, true, "Nombre", null, null, null, null, true, null);
    this.isMenuPadreSearching = true;

    this.service.search(r).subscribe(data => {
      this.isMenuPadreSearching = false;
      if (data != null)
        this.menuPadreList = data?.result;
    },
    (err: HttpErrorResponse) => {
      this.isMenuPadreSearching = false;
      this.sharedFunctions.handleError(err);
    });
  }

  onGridActionFailure(event: any): void {
    this.sharedFunctions.showMessage("Ocurrió un error intentando realizar la búsqueda", "Error");
  }

  onActionBegin(args: PageEventArgs) {
    if (args.requestType === 'paging' && !this.isSearching)
    {
      this.searchForm.get('gridPage')?.setValue(args.currentPage);
      this.sharedFunctions.setReporteFiltros("app-menuFuncionLista", this.searchForm.getRawValue());
    }
  }


  onSearch() {
    this.isSearching = true;

    this.searchForm.get('gridPage')?.setValue(1);
    this.sharedFunctions.setReporteFiltros("app-menuFuncionLista", this.searchForm.getRawValue());

    this.setQueryParams();

    this.grid.refresh();
    this.isSearching = false;
  }

  setQueryParams() {
    if (this.query == null)
      this.query = new Query();

    var index = this.query.params.findIndex(obj => obj.key === "Codigo");
    if (index >= 0)
      this.query.params[index].value = this.searchForm.value.Codigo;
    else
      this.query.addParams("Codigo",this.searchForm.value.Codigo);

    index = this.query.params.findIndex(obj => obj.key === "Nombre");
    if (index >= 0)
      this.query.params[index].value = this.searchForm.value.Nombre;
    else
      this.query.addParams("Nombre",this.searchForm.value.Nombre);

    index = this.query.params.findIndex(obj => obj.key === "RolId");
    if (index >= 0)
      this.query.params[index].value = this.searchForm.value.RolId;
    else
      this.query.addParams("RolId",this.searchForm.value.RolId);

    index = this.query.params.findIndex(obj => obj.key === "MenuPadreId");
    if (index >= 0)
      this.query.params[index].value = this.searchForm.value.MenuPadreId;
    else
      this.query.addParams("MenuPadreId",this.searchForm.value.MenuPadreId);

    index = this.query.params.findIndex(obj => obj.key === "VerSoloActivos");
    if (index >= 0)
      this.query.params[index].value = this.searchForm.value.VerSoloActivos;
    else
      this.query.addParams("VerSoloActivos", this.searchForm.value.VerSoloActivos);
  }

  add() {
    if (this.canAdd)
      this.router.navigate(['menu-edit', 0]);
    else
      this.sharedFunctions.showMessage("No puede ejecutar esta operación", "Error");
  }

  edit(item: MenuFuncion) {
    if (!item || item.Id == null || item.Id <= 0) {
      this.sharedFunctions.showMessage("Debe seleccionar un item", "Error");
      return false;
    }
    this.router.navigate(['menu-edit', item.Id]);
  }

  onExport() {
    var search = new SearchMenuFuncionRequestDto(null, null, null, "", null, null, null, null, null, null);
    search = Object.assign(search, this.searchForm.value);

    this.isExporting = true;
    this.service.exportSearch(search).subscribe((data: Blob) => {
      this.isExporting = false;
      var fileUrl = URL.createObjectURL(data);

      var anchor = document.createElement("a");
      anchor.download = "MenuFunciones_" + this.datePipe.transform(new Date(),"yyyy-MM-dd") + this.sharedFunctions.getFileExtension(ExportMediaTypeConstants.Csv);
      anchor.href = fileUrl;
      anchor.click();
    },
    (err: HttpErrorResponse) => {
      this.isExporting = false;
      this.sharedFunctions.handleError(err, true);
    })
  }
}
